import { normalizeJoinedEmail } from './joinedAccounts.js';

/**
 * Fold server membership and this browser's joined accounts into the people list.
 * Owners are unchanged. A teammate who created an account is Active, with their photo.
 */
export function applyOrgRoster(orgUsers, { members = [], joined = {}, profileLookup } = {}) {
  const remote = new Map();
  for (const member of members || []) {
    const email = normalizeJoinedEmail(member?.email || member?.Member_Email);
    if (email) remote.set(email, member);
  }

  return (orgUsers || []).map((person) => {
    if (!person || person.role === 'OWNER') return person;
    const email = normalizeJoinedEmail(person.email);
    const member = email ? remote.get(email) : null;
    const local = email ? joined[email] : null;
    const saved = email && typeof profileLookup === 'function' ? profileLookup(email) : null;
    const knownPhoto = String(
      member?.avatarDataUrl || local?.avatarDataUrl || saved?.avatarDataUrl || ''
    ).trim();
    const avatar = knownPhoto || String(person.avatarDataUrl || '').trim();
    const hasAccount = Boolean(
      member?.hasAccount || member?.status === 'ACTIVE' || local || knownPhoto
    );
    if (!hasAccount && avatar === String(person.avatarDataUrl || '').trim()) return person;
    const remoteName = String(member?.displayName || local?.displayName || '').trim();
    return {
      ...person,
      status: hasAccount ? 'ACTIVE' : person.status,
      name: String(person.name || '').trim() || remoteName,
      avatarDataUrl: avatar,
    };
  });
}
